import firebase from 'firebase'
import { firebaseAction } from 'vuexfire'

const state = {
  mine: null
}
const getters = {
  mine: state => state.mine
}
const actions = {
  bind: firebaseAction(({ bindFirebaseRef }, user) => {
    if (user) {
      bindFirebaseRef('mine', firebase.firestore().collection('users').doc(user.uid), {maxRefDepth: 0})
    }
  })
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/profiles.js